import { useMemo } from 'react';
import { required } from 'js/utils/Validation/validationRules';
import { getFitToPlaySubmissionRequired } from 'js/hooks/auth/pas';
import { IValidationMethodConfigRequired } from 'js/utils/Validation/types';

export const useValidationConfig = () => {
    return useMemo(() => ({
        userName: [required() as IValidationMethodConfigRequired],
        password: [required() as IValidationMethodConfigRequired],
        ...getFitToPlaySubmissionRequired() ? { fitToPlay : [required() as IValidationMethodConfigRequired] } : {}
    }), []);
};
